import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Button from 'component/Button/index'
import FormModal from 'component/justifications-irc/FormModal'
import CloseWithoutSaveModal from 'component/justifications-irc/CloseWithoutSaveModal'
import DepositSideFilterForm from 'component/depositApproval/DepositSideFilterForm'
import NewPagination from 'component/pagination/newPagination'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SuccessModal from 'component/Modal/SuccessModal'
import * as depositActions from 'action/deposit'
import * as depositApprovalActions from 'action/depositApproval'
import FilterIconSVG from 'component/svgComponents/filter'
import SupplyErrorModal from 'component/justifications-irc/supplyErrorModal'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import DepositTable from 'component/depositApproval/DepositTable'
import 'component/justifications-irc/newTable.css'
import "../stockTransferNew/missionblocknew.css"
import { ViewModalContainer } from 'component/justifications-irc/ViewModalV2'
import Modal from 'component/Modal/index'
import TextField from 'component/justifications-irc/JustificationTextField'
import 'component/justifications-irc/styles.css'

class DepositApproval extends React.Component {

  constructor(props) {
    super(props)
    this.handleSingleEditModal = this.handleSingleEditModal.bind(this)
    this.updateStatus = this.updateStatus.bind(this)
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    count: PropTypes.number,
    current: PropTypes.number,
    fetchIrcJustifications: PropTypes.func,
    fetchDeleteIrcJustification: PropTypes.func,
    fetchUpdateIrcJustification: PropTypes.func,
    fetchDepositList: PropTypes.func,
    fetchDepositApprovalList: PropTypes.func.isRequired,
    updateWarehouseRequiresApproval: PropTypes.func.isRequired,
    saveIrcJustification: PropTypes.func,
    saveAllIrcJustification: PropTypes.func,
    mock: PropTypes.object,
    pages: PropTypes.number,
    validateProducts: PropTypes.func,
    isUserMatriz: PropTypes.bool,
    isFetching: PropTypes.bool,
    saveIrcSupplyList: PropTypes.func,
    fetchPositions: PropTypes.func,
    error: PropTypes.object,
    user: PropTypes.object,
    warehouseApprovals: PropTypes.object,
  }

  state = {
    sideFilterVisible: false,
    storeMatriz: '999',
    userMatriz: false,
    depositList: [],
    depositListWithoutPermission: [],
    updatingIds: [],
    filters: {
      idSourceDepositList: [],
      idDestinationDepositList: [],
      requiresApproval: '',
    },
    currentItem: false,
    currentJustification: false,
    newValues: false,
    csvFile: false,
    showProcessingModal: false,
    syncModal: {render:false, details: null},
    showEditModal: false,
    showUploadModal: false,
    errorSaveModal: false,
    successModalMsg: "",
    fileError: false,
    filterValues: {},
    errorModal: { render: false, details: null, detailsErrorMessage:null },
    closeWithoutSaveModal: false,
    closeWithoutSaveEditModal: false,
    maxDays: 5,
    missionsSelectBranchs: [],
    orderByAsc: false,
    page: 0,
    pages: 0,
    limit: 10,
    optionSize: 10,
    openOneEditModal: false,
  }

  componentDidMount(){
    this.fetchDepositList()
    this.fetchWarehouseApprovals()
  }

  fetchDepositList = () => {
    const {
      auth: {user},
      fetchDepositList
    } = this.props

    fetchDepositList(user.dsToken)
      .then((response) => {
        const depositList = response.payload || []
        this.setState({ 
          depositList,
          depositListWithoutPermission: depositList 
        })
      })
  }

  fetchWarehouseApprovals = () => {
    const {
      auth: {user},
      fetchDepositApprovalList
    } = this.props
    
    const { filters, page, optionSize } = this.state
    
    const apiFilters = {
      page,
      size: optionSize
    }
    
    if (filters.idSourceDepositList && filters.idSourceDepositList.length > 0) {
      apiFilters.sourceWarehouses = filters.idSourceDepositList.map(id => 
        typeof id === 'string' ? id.toLowerCase() : id
      )
    }
    
    if (filters.idDestinationDepositList && filters.idDestinationDepositList.length > 0) {
      apiFilters.destinationWarehouses = filters.idDestinationDepositList.map(id => 
        typeof id === 'string' ? id.toLowerCase() : id
      )
    }
    
    if (filters.requiresApproval !== '') {
      apiFilters.requiresApproval = filters.requiresApproval === 'true'
    }
    
    fetchDepositApprovalList(user.dsToken, apiFilters)
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.optionSize !== this.state.optionSize) {
      this.setState({page: 0}, () => this.fetchWarehouseApprovals())
    }
  }


  

  onUpdate = async (currentJustification) => {
    const { auth: { user }, fetchUpdateIrcJustification } = this.props;

    const updateParams = {
      idJustification: currentJustification.idJustification,
      dsJustification: currentJustification.dsJustification,
      dsType:currentJustification.dstype,
      type:currentJustification.type
    };

    const onSuccess = () => {
        this.setState({
          successModalMsg: "O depósito foi atualizado com sucesso!",
          csvFile: false,
          openOneEditModal: false
        });
  
    };

    const onError = (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Falha ao editar depósito.";
    
      const detailsErrorMessage =
        error?.response?.data?.dsMessage ||
        "Um depósito com a mesma descrição já foi registrado para este tipo.";
  
      this.setState({
        errorSaveModal: true,  
        errorModal: {
          dsMessage: errorMessage,
          detailsErrorMessage,
        },
        openOneEditModal: false,
      });
    };
    
    fetchUpdateIrcJustification(user.dsToken, updateParams, onSuccess, onError);
  }

  onSubmit = async (values) => {
    const { auth: { user }, saveIrcJustification, saveAllIrcJustification } = this.props;

    const saveParams = {
      dsJustification: values.dsListName, 
      dsType: values.type === "1" ? "C050-Loja" : (values.type === "0" ? "C010-Supply" : ""),
      inInactive: values.inInactive !== undefined ? values.inInactive : 0,
      inNotCounted:0,
      justifications: values.justifications
    };

    if (saveParams.dsType === "C050-Loja") {
      saveParams.inInactive = values.inInactive;  
    }

    if (saveParams.dsType === "C010-Supply") {
      saveParams.cdLdap = Number(user.username);
      saveParams.dsLdap = user.fullName; 
    }

    const onSuccess = () => {
      this.setState({
        successModalMsg: "O depósito foi cadastrado com sucesso!",
        csvFile: false,
      });

    };

    const onError = (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Falha ao salvar depósito.";
      
      const detailsErrorMessage =
        error?.response?.data?.dsMessage ||
        "Um depósito com a mesma descrição já foi registrado para este tipo.";


      this.setState({
        errorSaveModal: true,
        errorModal: {
          render: true,
          isUpload: false,
          dsMessage: errorMessage,
          detailsErrorMessage
        },
      });
    };

    if (Array.isArray(saveParams.justifications) && saveParams.justifications.length > 0) {
      saveAllIrcJustification(user.dsToken, saveParams, onSuccess, onError);
    } else {
      saveIrcJustification(user.dsToken, saveParams, onSuccess, onError);
    }
  }
  
  toggleEdit = (show, irc = {}, closeWithoutSaveModal = false, newValues) => {
    this.setState({ showEditModal: show, currentItem: irc, closeWithoutSaveModal, newValues })
  }

  toggleEditModal = (show, closeWithoutSaveEditModal = false) => {
    this.setState({showEditModal: show, closeWithoutSaveEditModal})
  }

  changeDsJustificationEdit(value) {
    const {currentJustification} = this.state

    const newJustification = {...currentJustification}
    newJustification.dsJustification = value
    this.setState({currentJustification: newJustification})
  }

  handleSingleEditModal(item) {
    this.setState({openOneEditModal: true, currentJustification: item})
  }

  updateStatus(idWarehouseApproval, requiresApproval) {
    this.setState(prevState => ({
      warehouseApprovals: prevState.warehouseApprovals.map(item =>
        item.idWarehouseApproval === idWarehouseApproval
          ? { ...item, requiresApproval }
          : item
      )
    }));
  }

  handleToggleRequiresApproval = async (idWarehouseApproval, newRequiresApproval) => {
    const { 
      auth: { user }, 
      updateWarehouseRequiresApproval 
    } = this.props


    this.setState(prevState => ({
      updatingIds: [...prevState.updatingIds, idWarehouseApproval]
    }))

    try {
      await updateWarehouseRequiresApproval(user.dsToken, idWarehouseApproval, newRequiresApproval)
      
      // Remove from updating list - the reducer will handle the data update
      this.setState(prevState => ({
        updatingIds: prevState.updatingIds.filter(id => id !== idWarehouseApproval)
      }))
    } catch (error) {
      this.setState(prevState => ({
        updatingIds: prevState.updatingIds.filter(id => id !== idWarehouseApproval)
      }))
    }
  }

  renderSingleEditModal() {

    const {currentJustification, openOneEditModal} = this.state
    const {translate} = this.props
    if(!openOneEditModal) return

    return (
      <Modal
        invisible={false}
        className={`justification-modal irc-form-modal`}
        title={"Editar depósito"}
        cancelButtonText={"Cancelar"}
        confirmButtonText={"Salvar"}
        disabledBgClickClosing
        isConfirmButtonDisabled={!currentJustification.dsJustification}
        isOpen
        noCloseOnConfirm
        onConfirm={() => this.onUpdate(currentJustification)}
        onCloseModal={() => this.setState({openOneEditModal: false, currentJustification: false})}
      >

        <form action='#' onSubmit={(e) => e.preventDefault()} className='w-100'>
          <TextField
            required
            clearIcon
            label={"Depósito"}
            placeholder={"Digite o nome do depósito"}
            name={'dsListName'}
            onRightIconClick={() => this.changeDsJustificationEdit("")}
            fill
            onChange={(e) => this.changeDsJustificationEdit(e.target.value)}
            translate={translate}
            value={currentJustification.dsJustification}
            validateValue={(v) => Boolean(v)}
          >
            
          </TextField>
        </form>

      </Modal>
    )
  }

  renderEditModal() {
    const {
      translate,
      auth: { user },
      isUserMatriz,
    } = this.props
    const { currentItem, closeWithoutSaveEditModal, showEditModal, newValues , maxDays, justifications} = this.state

      if(showEditModal) {
        return (
          <FormModal
            hideModal={closeWithoutSaveEditModal}
            maxDays={maxDays || 5}
            translate={translate}
            user={user}
            edit={currentItem}
            onSubmit={this.onSubmit}
            toggleEdit={this.toggleEditModal}
            isUserMatriz={isUserMatriz}
            newValues={newValues}
            onAddJustifications={(justifications)}
          />
        )
      }
  }

  toggleView = (show, irc) => {
    this.setState({ showViewModal: show, currentItem: irc })
  }

  renderViewModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showViewModal } = this.state

    if(!showViewModal) return

    return (
        <ViewModalContainer
          translate={translate}
          user={user}
          currentItem={currentItem}
          toggleView={this.toggleView}
          toggleEdit={this.toggleEdit}
          toggleUpload={this.toggleUpload}
        />
      )
    
  }

  renderCloseWithoutSaveEditModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveEditModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveEditModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggleEditModal={this.toggleEditModal}
        />
      )
    }
  }

  renderCloseWithoutSaveModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggle={this.toggleUpload}
        />
      )
    }
  }

  onFilter = (values) => {
    const newValues  ={ ...values}
    newValues.orderByAsc = this.state.orderByAsc
    this.setState({ sideFilterVisible: false, filterValues: values, page: 0 }, () => {
      this.fetchWarehouseApprovals()
    })
  }


  onSideFilter = (values) => {
    this.setState({ 
      sideFilterVisible: false, 
      filters: { ...this.state.filters, ...values },
      page: 0
    }, () => {
      this.fetchWarehouseApprovals()
    })
  }

  renderSideFilterForm() {
    const { translate } = this.props
    const { sideFilterVisible, depositListWithoutPermission, filters } = this.state

    return (
      <DepositSideFilterForm
        sideFilterVisible={sideFilterVisible}
        closeFilters={() => this.setState({ sideFilterVisible: false })}
        submit={this.onSideFilter}
        translate={translate}
        depositList={depositListWithoutPermission}
        initialValues={{
          idSourceDepositList: [],
          idDestinationDepositList: [],
          requiresApproval: '',
        }}
        btnDisabled={false}
        resetFilters={() => this.setState({
          filters: {
            ...filters,
            idSourceDepositList: [],
            idDestinationDepositList: [],
            requiresApproval: '',
          }
        })}
      />
    )
  }

  renderErrorModal = () => {
    const { translate } = this.props
    const {
      errorSaveModal,
      errorModal: { dsMessage, detailsErrorMessage }
    } = this.state

    if(errorSaveModal) {
      return (
        <SupplyErrorModal
          className="irc-supply-error-modal"
          center
          size='sm'
          t={translate}
          handleClose={() => this.setState({
            errorSaveModal: false,
          })}
          msg={dsMessage}
          detailsErrorMessage={detailsErrorMessage}
        />
      )

    }
 
  }

  renderNewPagination = () => {
    const {translate, warehouseApprovals} = this.props
    const {optionSize} = this.state
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

      
    const countItems = () => {
      if(!warehouseApprovals || warehouseApprovals.number + 1 === 1) return 1
      return (((warehouseApprovals.number + 1) - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if(!warehouseApprovals || !warehouseApprovals.content || warehouseApprovals.content.length === 0 || warehouseApprovals.totalElements === 0) return 

    return (
      <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center margin-bottom ">

          <NewPagination
          navClass='pagination new-relatory'
          count={warehouseApprovals.totalElements}
          current={warehouseApprovals.number + 1}
          getPage={(page) => this.setState({page: page - 1}, () => this.fetchWarehouseApprovals())}
          pages={warehouseApprovals.totalPages}
          />

          <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
            <Col xs={4}>
              <SizeSelect
                components={{DropdownIndicator}}
                isSearchable={false}
                styles={colourStyles}
                classNamePrefix='react-select'
                onChange={(option) => {
                  this.setState({optionSize: option.value})
                }}
                options={PAGINATION_OPTIONS}
                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                menuPlacement='top'
              />
            </Col>
          </div>

          <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
            <Col >{`
            ${translate('pagination.size.show')}
            ${countItems()} - ${(warehouseApprovals.number + 1) * optionSize > warehouseApprovals.totalElements ? warehouseApprovals.totalElements : (warehouseApprovals.number + 1) * optionSize }
            ${translate("pagination.size.of")}
            ${warehouseApprovals.totalElements}
            ${translate("pagination.size.items")}`}
            </Col>
          </div>
        </Col>
      </Row>
    )
  }


  render() {
    const {
      translate,
      warehouseApprovals
    } = this.props
    const { successModalMsg} = this.state

    return (
      <div className='stock-adjustment'>
        <div className='new-style'>
          <ContentHeader>{"Transferências com aprovação"}</ContentHeader>

          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              <div className='col-xs-13'>
                <div style={{marginRight:"5px"}} className='float-right'>
                  <Button
                    className='new-button-style deposit-approval-adjust'
                    text={translate('mobile.filter')}
                    onClick={() => this.setState({ sideFilterVisible: true })}
                    svgIcon
                    svgComponent={<FilterIconSVG newDesign={false} className=" common-download size-filter-default-svg" /> }
                  />
                </div>
              </div>
            </section>
          </div>

        </div>
      
        <div style={{marginTop: "20px"}} className='stock-adjustment-table new'>

          <div style={{boxShadow: (warehouseApprovals && warehouseApprovals.content && warehouseApprovals.content.length > 0) ? undefined : 'none'}} className='outer-table stock-transfer-outer-table'>
            {warehouseApprovals && warehouseApprovals.content && warehouseApprovals.content.length > 0 ? (
              <DepositTable
                deposits={warehouseApprovals.content}
                translate={translate}
                onToggleRequiresApproval={this.handleToggleRequiresApproval}
                updatingIds={this.state.updatingIds}
              />
            ) : (
             <div
                  style={{ width: '100%', height: '500px', margin: '0px' }}
                  className='relatory-no-data pictogram-empty'
                >
                  <p style={{ fontSize: '24px' }}>{translate('no.results')}</p>
                  <p className='no-result-filter'>{translate('no.results.please')}</p>
              </div>
            )}
            {this.renderNewPagination()}
          </div>

        </div>
        {this.renderSideFilterForm()}
        {this.renderViewModal()}
        {this.renderCloseWithoutSaveModal()}
        {this.renderCloseWithoutSaveEditModal()}
        {this.renderEditModal()}
        {this.renderErrorModal()}
        {this.renderSingleEditModal()}
        {successModalMsg && (
          <SuccessModal
            center
            t={translate}
            msg={successModalMsg}
            size='sm'
            handleClose={() => {
              this.setState({ successModalMsg: false })
            }}
            fillButton
            buttonText='OK'
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, depositApprovalReducer }) => 
   ({
    warehouseApprovals: depositApprovalReducer.list,
    isFetching: depositApprovalReducer.isFetching,
    isUserMatriz: auth.isUserMatriz,
  })

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    fetchDepositList: depositActions.fetch,
    fetchDepositApprovalList: depositApprovalActions.fetchDepositApprovalList,
    updateWarehouseRequiresApproval: depositApprovalActions.updateWarehouseRequiresApproval,
  }, dispatch)

const DepositApprovalTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(DepositApproval)

export default connect(mapStateToProps, mapDispatchToProps)(DepositApprovalTranslated)

export { DepositApproval }